import React from 'react';
import { clsx } from 'js/utils/classNames.util';
import { Icon } from 'js/components/common/Icon';
import { I18n } from 'js/components/common/I18n';

import * as Types from './types';

import '../../FormFields.scss';
import style from './FormErrorMessage.scss';

export const FormErrorMessage: React.FC<Types.IFormErrorMessageProps> = ({
    message,
    children,
    className = '',
    classNames = {}
}) => (
    <div className={clsx([style.container, className, classNames.container, 'cms-form-error-message'])}>
        <Icon type="muiError" className={clsx([style.icon, classNames.icon])} />
        <div className={clsx([style.message, classNames.message])}>
            {message && <I18n tKey={message} defaultValue={message} />}
            {children}
        </div>
    </div>
);
